import MultiSelectFilter from "./MultiSelectFilter";
import {
  reducer,
  mapStateToProps,
  mapDispatchToProps,
} from "../FilterToolbar/FilterToolbar.state";

MultiSelectFilter.reducer = reducer;
MultiSelectFilter.mapDispatchToProps = mapDispatchToProps;
MultiSelectFilter.mapStateToProps = mapStateToProps;

export default MultiSelectFilter;
